/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./locale-data/complete.js (ignored)
// module id = 7
// module chunks = polyfills